import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { plainToInstance } from 'class-transformer';
import { Observable, map } from 'rxjs';

import { ApiKey } from '../../models/api-key.model';
import { JSend } from '../../models/jsend.model';

@Injectable({
  providedIn: 'root'
})
export class ApplicationsProxyService {

  private baseUrl = '/:apiApplicationProxy/';
  private apiKeysUrl = this.baseUrl + '/companies/:companyId/api/keys'

  constructor(private http: HttpClient) { }

  public get(companyId: number): Observable<ApiKey[]> {
    const url = this.apiKeysUrl.replace(':companyId', String(companyId));

    return this.http.get<JSend<{
      keys: ApiKey[];
    }>>(url).pipe(map(response => plainToInstance(ApiKey, response.data.keys)));
  }

  public delete(companyId: number, api_key: string): Observable<any> {
    const url = this.apiKeysUrl.replace(':companyId', String(companyId));

    return this.http.delete<JSend>(url, { body: { api_key } });
  }

  public create(companyId: number): Observable<ApiKey> {
    const url = this.apiKeysUrl.replace(':companyId', String(companyId));

    return this.http.post<JSend<{
      key: ApiKey;
    }>>(url, {}).pipe(map(response => plainToInstance(ApiKey, response.data.key)));
  }
}
